import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';
import { addCssPrefixTo } from 'utils';
import ServiceImage from 'components/ServiceImage';
import { getGuestDirectoryServiceIconPath } from 'selectors/guestDirectory';
import { ServiceContainer, TextContainer, ServiceName } from '../ServiceLink/styles';
import { GuestDirectoryContainer } from './styles';

const messages = defineMessages({
  guestDirectory: {
    defaultMessage: 'Guest Directory',
  },
});

interface Props {
  compact?: boolean;
}

const GuestDirectoryButton: React.FC<Props> = ({ compact }) => {
  const serviceIconPath = useSelector(getGuestDirectoryServiceIconPath);

  return (
    <GuestDirectoryContainer>
      <Link to="/guest-directory">
        <ServiceContainer compact={compact} className={addCssPrefixTo('GUEST_DIRECTORY_CONTAINER')}>
          <div>
            {compact && <ServiceImage src={serviceIconPath || undefined} />}
            <TextContainer compact={compact}>
              <ServiceName compact={compact}>
                <FormattedMessage {...messages.guestDirectory} />
              </ServiceName>
            </TextContainer>
          </div>
        </ServiceContainer>
      </Link>
    </GuestDirectoryContainer>
  );
};

export default GuestDirectoryButton;
